import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { useEffect } from "react";

import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { initNativeShell, isNative } from "./lib/native";
import { AnalyticsRouter } from "./lib/track";

import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import RootRoute from "./components/RootRoute";

import Auth from "./pages/Auth";
import AuthCallback from "./pages/AuthCallback";
import Home from "./pages/Home";
import Onboarding from "./pages/Onboarding";
import Practice from "./pages/Practice";
import Results from "./pages/Results";
import History from "./pages/History";
import Insights from "./pages/Insights";
import Settings from "./pages/Settings";
import SessionDetail from "./pages/SessionDetail";
import Brand from "./pages/Brand";
import Admin from "./pages/Admin";
import PublicSession from "./pages/PublicSession";

import "./App.css";

export default function App() {
    useEffect(() => {
        // Only register the PWA service worker on web; native shell handles its own lifecycle.
        if (!isNative() && "serviceWorker" in navigator) {
            navigator.serviceWorker.register("/sw.js").catch(() => {});
        }
        initNativeShell().catch(() => {});
    }, []);

    return (
        <ThemeProvider>
            <AuthProvider>
                <BrowserRouter>
                    <AnalyticsRouter />
                    <Routes>
                        <Route path="/" element={<RootRoute />} />
                        <Route path="/brand" element={<Brand />} />
                        <Route path="/admin" element={<Admin />} />
                        <Route path="/auth" element={<Auth />} />
                        <Route path="/auth/google/callback" element={<AuthCallback />} />
                        <Route path="/s/:sessionId" element={<PublicSession />} />
                        <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />
                        <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
                            <Route path="/home" element={<Home />} />
                            <Route path="/practice/:promptId" element={<Practice />} />
                            <Route path="/practice" element={<Practice />} />
                            <Route path="/results/:sessionId" element={<Results />} />
                            <Route path="/history" element={<History />} />
                            <Route path="/insights" element={<Insights />} />
                            <Route path="/settings" element={<Settings />} />
                            <Route path="/session/:sessionId" element={<SessionDetail />} />
                        </Route>
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </BrowserRouter>
                <Toaster position="top-center" richColors />
            </AuthProvider>
        </ThemeProvider>
    );
}
